import { __decorate } from 'tslib';
import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { isUndefined } from 'util';
import { RESPONSE_TYPE, HTTP_METHOD } from '@projektionisten/mobi-template-model';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
let AngularHttpClient = class AngularHttpClient {
    constructor(httpClient) {
        this.httpClient = httpClient;
        // empty constructor
    }
    performHttpRequest(url, options) {
        const processedOptions = {
            headers: {},
            responseType: !isUndefined(options.responseType) && options.responseType !== RESPONSE_TYPE.XML
                ? options.responseType
                : 'json'
        };
        let request;
        let processedHeaders = new HttpHeaders();
        if (!isUndefined(options.headers)) {
            for (const header of options.headers) {
                processedHeaders = processedHeaders.set(header.key, header.value);
            }
            processedOptions.headers = processedHeaders;
        }
        if (!isUndefined(options.method)) {
            options.payload = !isUndefined(options.payload) ? options.payload : {};
            switch (options.method) {
                case HTTP_METHOD.GET:
                    let params = new HttpParams();
                    for (const param in options.payload) {
                        if (options.payload.hasOwnProperty(param)) {
                            if (Array.isArray(options.payload[param])) {
                                for (const value of options.payload[param]) {
                                    params = params.append(param, value);
                                }
                            }
                            else {
                                params = params.set(param, options.payload[param]);
                            }
                        }
                    }
                    request = this.httpClient.get(url, {
                        headers: processedHeaders,
                        params: params,
                        responseType: processedOptions.responseType,
                        observe: 'response'
                    });
                    break;
                case HTTP_METHOD.POST:
                    request = this.httpClient.post(url, options.payload, {
                        headers: processedHeaders,
                        responseType: processedOptions.responseType,
                        observe: 'response'
                    });
                    break;
                case HTTP_METHOD.PUT: {
                    request = this.httpClient.put(url, {
                        headers: processedHeaders,
                        params: options.payload,
                        responseType: processedOptions.responseType,
                        observe: 'response'
                    });
                    break;
                }
                case HTTP_METHOD.DELETE: {
                    request = this.httpClient.delete(url, {
                        headers: processedHeaders,
                        responseType: processedOptions.responseType,
                        observe: 'response'
                    });
                    break;
                }
                default:
                    break;
            }
        }
        return request.pipe(map((response) => {
            const headerKeys = response.headers.keys();
            const headers = headerKeys.map((key) => { return { key: key, value: response.headers.get(key) }; });
            let parsedData;
            if (response.body !== undefined) {
                if (options.responseType === RESPONSE_TYPE.JSON && typeof response.body === 'string') {
                    parsedData = JSON.parse(response.body);
                }
                else {
                    parsedData = response.body;
                }
            }
            return {
                status: {
                    code: response.status,
                    message: response.statusText
                },
                body: parsedData,
                headers: headers
            };
        }), catchError((response) => {
            return throwError(response);
        }));
    }
};
AngularHttpClient.ɵfac = function AngularHttpClient_Factory(t) { return new (t || AngularHttpClient)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
AngularHttpClient.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AngularHttpClient, factory: function (t) { return AngularHttpClient.ɵfac(t); } });
AngularHttpClient.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AngularHttpClient, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AngularHttpClient };

//# sourceMappingURL=projektionisten-http-client-angular.js.map